import { render } from "./MyMenteesPage.vue?vue&type=template&id=1841c86a"
import script from "./MyMenteesPage.vue?vue&type=script&lang=js"
export * from "./MyMenteesPage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__